import util from '@bmp-vue/core/api/util'

const base = 'MfaOtp'

export default {
  IniciarCadastro(config) {
    return util.Axios.Post(`${base}/Cadastrar`, {}, config)
  },

  ValidarCadastro(payload, config) {
    return util.Axios.Post(`${base}/Validar`, payload, config)
  }
}
